import { effect, inject, Injectable } from "@angular/core";
import { EntryPageResource } from "core/stages-client";
import { AuthService } from "core/auth/auth.service";

type EntryPage = stages.entrypage.EntryPage;
type EntryPageTab = stages.entrypage.EntryPageTab;

@Injectable({ providedIn: "root" })
export class EntryPagesService {
	private readonly entryPageResource = inject(EntryPageResource);
	private readonly auth = inject(AuthService);

	entryPagesMap: Map<string, { version: number; page: EntryPage }>;

	constructor() {
		this.entryPagesMap = new Map<string, { version: number; page: EntryPage }>();
		effect(() => {
			this.auth.isAuthenticated();
			this.invalidateCache();
		});
	}

	async getEntryPage(tab: EntryPageTab): Promise<EntryPage> {
		const cacheEntry = this.entryPagesMap.get(tab.id);
		if (cacheEntry && cacheEntry.version === tab.version) {
			return cacheEntry.page;
		}
		const entryPage = await this.refreshEntryPage(tab);
		this.entryPagesMap.set(tab.id, { version: tab.version, page: entryPage });
		return entryPage;
	}

	async refreshEntryPage(tab: EntryPageTab): Promise<EntryPage> {
		const refreshedPage = await this.entryPageResource.getEntryPage(tab.id);
		this.entryPagesMap.delete(tab.id);
		return refreshedPage;
	}

	private invalidateCache(): void {
		this.entryPagesMap.clear();
	}
}
